import { useState } from "react";
import { typeFilters, yearFilters } from "@/mocks/home";

const sortOptions = [
  { key: "latest", label: "最新在前" },
  { key: "hot", label: "热度优先" },
  { key: "oldest", label: "从早看起" },
];

export default function FilterBar() {
  const [year, setYear] = useState(yearFilters[0]);
  const [type, setType] = useState(typeFilters[0]);
  const [sort, setSort] = useState("latest");

  const matched = 6 + (year === "全部年份" ? 0 : 1) + (type === "全部类型" ? 0 : 1);

  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-6 md:py-7">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
          <div className="flex flex-col gap-4">
            <div className="flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-filter-3-line" />
                年份
              </span>
              <div className="flex flex-wrap gap-2">
                {yearFilters.map((item) => (
                  <button
                    key={item}
                    type="button"
                    onClick={() => setYear(item)}
                    className={`h-8 px-3.5 rounded-full text-xs transition-colors whitespace-nowrap cursor-pointer ${
                      year === item
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-50 border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
                    }`}
                  >
                    {item}
                  </button>
                ))}
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-price-tag-3-line" />
                类型
              </span>
              <div className="flex flex-wrap gap-2">
                {typeFilters.map((item) => (
                  <button
                    key={item}
                    type="button"
                    onClick={() => setType(item)}
                    className={`h-8 px-3.5 rounded-full text-xs transition-colors whitespace-nowrap cursor-pointer ${
                      type === item
                        ? "bg-secondary-500 text-background-50"
                        : "bg-background-50 border border-background-300 text-foreground-700 hover:border-secondary-400 hover:text-secondary-700"
                    }`}
                  >
                    {item}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center gap-3">
            <span className="text-xs text-foreground-600 whitespace-nowrap">
              共匹配 <strong className="text-primary-600 font-semibold">{matched}</strong> 条归档
            </span>
            <div className="inline-flex items-center gap-1 p-1 rounded-full bg-background-200">
              {sortOptions.map((option) => (
                <button
                  key={option.key}
                  type="button"
                  onClick={() => setSort(option.key)}
                  className={`h-8 px-3.5 rounded-full text-xs transition-colors whitespace-nowrap cursor-pointer ${
                    sort === option.key
                      ? "bg-background-50 text-foreground-950"
                      : "text-foreground-600 hover:text-foreground-900"
                  }`}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}